import { View, styled } from 'tamagui'
import { useAppStore } from '@/store'
import { ServerSettingsNav } from './ServerSettingsNav'
import { OverviewSettings } from './OverviewSettings'
import { ChannelSettings } from './ChannelSettings'
import { RoleSettings } from './RoleSettings'
import { MemberSettings } from './MemberSettings'
import { InviteSettings } from './InviteSettings'
import { SafetySettings } from './SafetySettings'
import { BillingSettings } from './BillingSettings'
import { ServerEmojiSettings } from './ServerEmojiSettings'
import { AuditLogSettings } from './AuditLogSettings'
import { WebhookSettings } from './WebhookSettings'

const Container = styled(View, {
  flex: 1,
  flexDirection: 'row',
  backgroundColor: '$surface',
})

const Content = styled(View, {
  flex: 1,
  overflow: 'hidden',
})

function SettingsContent() {
  const { serverSettingsTab } = useAppStore()

  switch (serverSettingsTab) {
    case 'overview': return <OverviewSettings />
    case 'channels': return <ChannelSettings />
    case 'roles': return <RoleSettings />
    case 'members': return <MemberSettings />
    case 'invites': return <InviteSettings />
    case 'safety': return <SafetySettings />
    case 'billing': return <BillingSettings />
    case 'emoji': return <ServerEmojiSettings />
    case 'audit-log': return <AuditLogSettings />
    case 'webhooks': return <WebhookSettings />
    default: return <OverviewSettings />
  }
}

export function ServerSettings() {
  return (
    <Container>
      <ServerSettingsNav />
      <Content>
        <SettingsContent />
      </Content>
    </Container>
  )
}
